import React from "react";
import {
  WARNING_MESSAGE_POPUP_BACKGROUND_COLOR_GRADIENT,
  COLOR_WARNING_TRIANGLE,
} from "../theme";
import AlertTriangle from "../icons/AlertTriangle";
import Popup from "./Popup";

interface RegenerateDocumentPopupProps {
  onCancel: () => void;
  onConfirm: () => void;
}

const RegenerateDocumentPopup: React.FC<RegenerateDocumentPopupProps> = ({
  onCancel,
  onConfirm,
}) => {
  return (
    <Popup
      backgroundColor={WARNING_MESSAGE_POPUP_BACKGROUND_COLOR_GRADIENT}
      icon={<AlertTriangle triangleColor={COLOR_WARNING_TRIANGLE} />}
      title="Are you sure you want to go back to questionnaire and regenerate your document?"
      description="This will reset your document to allow for new changes, but you'll need to review and approve it again."
      buttons={{
        confirmText: "Yes, regenerate",
        cancelText: "Cancel",
        onConfirm: onConfirm,
        onCancel: onCancel,
      }}
    />
  );
};

export default RegenerateDocumentPopup;
